module.exports = __webpack_public_path__ + "img/astronaut2.c4dffcd1.jpg";